import $ from 'jquery';
import 'slick-carousel';

export const init = ($target) => {

	$target.find('.b-gallery--full .b-gallery__list').each(function() {
		var $this = $(this);

		$this
			.slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				arrows: false,
				variableWidth: true,
				dots: false,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 2000,
			});
	});

	// v 2
	$target.find('.b-main-image').each(function () {

		var $this = $(this);
		var $scroll = $this.find('.b-main-image__list');
		var $thumbs = $this.find('.b-thumb-images__item');

		$scroll
			.slick({
				arrows: false,
			})
			.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$thumbs
					.removeClass('is-active')
					.eq(nextSlide).addClass('is-active');
			});

		$thumbs
			.on('click', function (e) {
				e.preventDefault();
				$scroll.slick('slickGoTo', $(this).index());
			});

	});

};
